import { createContext, useContext, useMemo } from 'react';
import {
  ICheckoutComEvents,
  checkoutcomCardFormMachine,
} from '../stateMachines';
import { useMachine } from '@monofront/xstate-v4/react';
import { StateFrom, Sender, InterpreterFrom } from '@monofront/xstate-v4';
import { v4 as uuid } from 'uuid';
interface ICheckoutComMachineContext {
  state: StateFrom<typeof checkoutcomCardFormMachine>;
  send: Sender<ICheckoutComEvents>;
  interpreter: InterpreterFrom<typeof checkoutcomCardFormMachine> | null;
}

const CheckoutComMachineContext = createContext<ICheckoutComMachineContext>({
  state: checkoutcomCardFormMachine.initialState,
  send: () => undefined,
  interpreter: null,
});

const CheckoutComMachineProvider = ({ children, sendMessageToMobile }) => {
  const generatedCheckout3dsId = useMemo(() => uuid().toString(), []);

  const [state, send, interpreter] = useMachine(
    checkoutcomCardFormMachine.withConfig({
      actions: {
        create3dsToken: () => {
          sendMessageToMobile('3dsStarted', { generatedCheckout3dsId });
        },
        remove3dsToken: () => {
          sendMessageToMobile('3dsStopped');
        },
      },
    }),
  );

  return (
    <CheckoutComMachineContext.Provider value={{ state, send, interpreter }}>
      {children}
    </CheckoutComMachineContext.Provider>
  );
};

const useCheckoutComMachine = () => useContext(CheckoutComMachineContext);

export { CheckoutComMachineProvider, useCheckoutComMachine };
